import React from 'react'
import { Typography, Box, Link, Grid } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import { useNavigate } from 'react-router-dom'
import DealerSignupSection from 'components/DealerSignupSection'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Box sx={{ position: 'relative', minHeight: '80vh' }}>
      <FixedWidthContainer sx={{ my: '50px' }}>
        <Grid container spacing={4} alignItems='center' justifyContent='center'>
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Box
              component='img'
              src='/404-banner.png'
              alt='404 Error'
              sx={{ width: 604, height: 362 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              textAlign='center'
            >
              <Typography variant='h2' sx={{ mb: 2 }}>
                We are sorry,
              </Typography>
              <Typography variant='body1' sx={{ mb: 4 }}>
                But the page you are looking for cannot be found.
              </Typography>

              <Typography variant='body2' sx={{ mb: 1 }}>
                If you typed the URL directly please make sure the spelling is
                correct.
              </Typography>
              <Typography variant='body2' sx={{ mb: 2 }}>
                If you are not sure how you got here,{' '}
                <Link
                  onClick={() => navigate(-1)}
                  sx={{
                    cursor: 'pointer',
                    color: 'primary.main',
                    textDecoration: 'none'
                  }}
                >
                  go back
                </Link>{' '}
                to the previous page or return to our{' '}
                <Link
                  onClick={() => navigate('/')}
                  sx={{
                    cursor: 'pointer',
                    color: 'primary.main',
                    textDecoration: 'none'
                  }}
                >
                  Home Page
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </FixedWidthContainer>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0
        }}
      >
        <DealerSignupSection />
      </Box>
    </Box>
  )
}

export default NotFoundPage
